// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"643":"8176539d1e9e91c1","915":"e32e3afd3e551b48"}[chunkId] + ".js";
};